import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from './SEOHead';
import LandingFooter from './LandingFooter';

const serif = { fontFamily: '"DM Serif Display", Georgia, serif' };
const ACCENT = '#1a5fff';

const LINKS = [
  ['Home', '/'],
  ['Features', '/features'],
  ['Pricing', '/pricing'],
  ['Contact', '/contact'],
  ['Log in', '/login'],
];

const NotFound = () => (
  <>
    <SEOHead title="Page not found" description="The page you were looking for doesn't exist." noindex />

    <section style={{ padding: '96px 5%', background: 'linear-gradient(160deg,#f0f4ff 0%,#ffffff 100%)', textAlign: 'center' }}>
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <div style={{ fontSize: 12, fontWeight: 500, color: ACCENT, letterSpacing: '.08em', textTransform: 'uppercase', marginBottom: 12 }}>Error 404</div>
        <h1 style={{ ...serif, fontSize: 'clamp(32px,4.5vw,52px)', lineHeight: 1.1, letterSpacing: '-.03em', color: '#0d1117', marginBottom: 16 }}>
          We couldn't find that <em style={{ fontStyle: 'italic', color: ACCENT }}>page</em>
        </h1>
        <p style={{ fontSize: 17, color: '#3a3f4a', lineHeight: 1.65, marginBottom: 32 }}>
          The link may be old or mistyped. Try one of these instead:
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
          {LINKS.map(([label, to], i) => (
            <Link key={to} to={to} style={{
              display: 'inline-flex', alignItems: 'center', padding: '11px 22px', borderRadius: 12,
              fontSize: 14, fontWeight: 500, textDecoration: 'none',
              background: i === 0 ? ACCENT : 'transparent', color: i === 0 ? '#fff' : '#3a3f4a',
              border: i === 0 ? 'none' : '1px solid #e4e7ed',
            }}>{label}</Link>
          ))}
        </div>
      </div>
    </section>

    <LandingFooter />
  </>
);

export default NotFound;
